export const initialState = {
	surveyGuidMaps: {
		isSyncing: {},
		isUnsyncing: {},
		isDeleting: {},
		isDeleted: {},
		isQueuedForDelete: {},
		isSelected: {},
		errorMessages: {},
	},
};

export default initialState;
